export enum JobType {
  GENERAL,
  INSPECTION,
  ISSUE,
  MAINTENANCE,
  WORK_ORDER,
  MILL_ORDER
}

export enum JobLabelType {
  GENERAL = 'General',
  INSPECTION = 'Inspection',
  ISSUE = 'Issue',
  MAINTENANCE = 'Maintenance',
  WORK_ORDER = 'Purchase order',
  MILL_ORDER = 'Mill order'
}

export const JobTypeLabel = {
  [JobType.GENERAL]: 'General',
  [JobType.INSPECTION]: 'Inspection',
  [JobType.ISSUE]: 'Issue',
  [JobType.MAINTENANCE]: 'Maintenance',
  [JobType.WORK_ORDER]: 'Purchase order',
  [JobType.MILL_ORDER]: 'Mill order'
}

export enum JobIconType {
  GENERAL = 'mdi-account-hard-hat-outline',
  ISSUE = 'mdi-alert-outline',
  INSPECTION = 'mdi-magnify',
  WORK_ORDER = 'mdi-package-variant-closed',
  MAINTENANCE = 'mdi-hammer-wrench',
  MILL_ORDER = 'mdi-cog-outline'
}

export default JobType
